import styled, { keyframes } from "styled-components";
import { colors } from "../../../../theme";

const pulse = keyframes`
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
`;

/**
 * Generic skeleton bone. Pass height/width as CSS length strings
 * (e.g. "14px", "60%", "100%").
 */
const Skeleton = styled.div`
  display: block;
  background-color: ${colors.grey.medium};
  border-radius: ${(props) =>
    props.variant === "circle"
      ? "50%"
      : props.$radius != null
        ? props.$radius
        : "4px"};
  height: ${(props) => props.height || "1em"};
  width: ${(props) => props.width || "100%"};
  animation: ${pulse} 1.4s ease-in-out infinite;
`;

export default Skeleton;
